// extracted by mini-css-extract-plugin
module.exports = {"columns":"page_columns__MQJa8","content":"page_content__MMKJW","twoColumnList":"page_twoColumnList__QxXke","avatar":"page_avatar__ujrd4","rtColumns":"page_rtColumns__SHibV"};